import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuthToken, useMutation } from '..';

export interface RequestBodyField {
  platform?: string;
  handle?: string;
}

interface UseAccountDisconnectProps {
  platform: RequestBodyField;
  onSuccess?: (user: Api.UserObject | ResponseObject) => void;
}

export function useAccountDisconnect({ platform, onSuccess }: UseAccountDisconnectProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { isLoading, mutate, error, data } = useMutation({
    mutationKey: 'influencer-accounts-connect',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/account/disconnect`,
        body: { ...platform },
        token
      }).then((response: ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    data: data || {},
    isLoading,
    mutate,
    error
  };
}
